import { FC } from "react";
import { SquareArrowOutUpRight as SquareArrowOutUpRightIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnCard } from "@/components/VnCard";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import {
  AgentAssistedProgramType,
  SELF_ENROLLMENT_URL_BY_PROGRAM,
} from "@/domain/brokerConsent";
import { I18nKeyType } from "@/i18n";
import { getAgentAssistedProgramsLabel } from "@/utils/applications";
import { getProgramTypeLabel } from "@/utils/brandLabel";
import { openLinkInExternalBrowser } from "@/utils/linking";

type BrokerConsentDeclineCardPropsType = {
  agentAssistedPrograms: AgentAssistedProgramType[];
  fallbackI18nKey: I18nKeyType;
};

export const BrokerConsentDeclineCard: FC<
  BrokerConsentDeclineCardPropsType
> = ({ agentAssistedPrograms, fallbackI18nKey }) => (
  <VnCard className="gap-4">
    <VnText
      variant="headerTwo"
      i18nKey="native:brokerConsentScreen.declineCard.title"
    />
    <VnText
      variant="lg"
      className="text-muted-foreground"
      i18nKey="native:brokerConsentScreen.declineCard.selfEnrollmentWarning"
      i18nOptions={{
        programs: getAgentAssistedProgramsLabel(agentAssistedPrograms),
      }}
    />
    <VnText
      variant="lg"
      className="text-muted-foreground"
      i18nKey={fallbackI18nKey}
    />
    <VnBox className="gap-3">
      {agentAssistedPrograms.map(program => (
        <VnTouchableOpacity
          key={program}
          accessibilityRole="link"
          className="flex-row items-center gap-2 self-start"
          onPress={() => {
            void openLinkInExternalBrowser(
              SELF_ENROLLMENT_URL_BY_PROGRAM[program],
            );
          }}>
          <VnText
            variant="lgMedium"
            className="underline"
            i18nKey="native:brokerConsentScreen.declineCard.applyLink"
            i18nOptions={{ program: getProgramTypeLabel(program) }}
          />
          <VnIcon as={SquareArrowOutUpRightIcon} size={16} />
        </VnTouchableOpacity>
      ))}
    </VnBox>
  </VnCard>
);
